import { ProductType } from '@inter-ikea-storageone/range';
import { ProductListConfig } from 'rangeConfig/@types';
import { addProductWithFrontStyle } from 'rangeConfig/shared/behaviors/addProductWithFrontStyle';
import addProduct from 'rangeConfig/shared/behaviors/addProduct';
import UnsafeFrameMessage from 'rangeConfig/platsa/widgets/UnsafeFrameMessage';

const framesProductListConfig: ProductListConfig = {
  cardsSubtitle: 'typeName, designText, communicatedSizeText',
  mobileCardText: 'communicatedSizeText',
  productFilters: [],
  categories: [
    {
      id: 'frames-d-550',
      categoryTitle:
        'storageone.depth communicatedDimensionsLocalized.depth communicatedDimensionsLocalized.unit',
      products: [
        { path: 'type', value: ProductType.SMASTAD_FRAME },
        { path: 'communicatedDimensions.depth', value: 550 }
      ],
      widgets: [
        {
          component: UnsafeFrameMessage
        }
      ]
    },
    {
      id: 'frames-d-550-na-asm',
      cardsSubtitle: 'designText, communicatedSizeText',
      categoryTitle:
        'storageone.depth communicatedDimensionsLocalized.depth communicatedDimensionsLocalized.unit',
      products: [
        { path: 'type', value: ProductType.SMASTAD_FRAME_NA_ASM },
        { path: 'communicatedDimensions.depth', value: 550 }
      ]
    },
    {
      id: 'frames-d-400',
      categoryTitle:
        'storageone.depth communicatedDimensionsLocalized.depth communicatedDimensionsLocalized.unit',

      products: [
        { path: 'type', value: ProductType.SMASTAD_FRAME },
        { path: 'communicatedDimensions.depth', value: 400 }
      ]
    },
    {
      id: 'frames-d-300',
      categoryTitle: 'storageone.depth communicatedDimensionsLocalized.depth',
      products: [
        { path: 'type', value: ProductType.SMASTAD_FRAME },
        { path: 'communicatedDimensions.depth', value: 300 }
      ]
    },
    {
      id: 'pull-out-frames',
      categoryTitle: 'typeName',
      products: [
        { path: 'type', value: ProductType.SMASTAD_PULL_OUT_FRAME_108_ASM },
        { path: 'type', value: ProductType.SMASTAD_PULL_OUT_FRAME_196_ASM }
      ]
    }
  ],
  behaviors: {
    productClicked: [addProductWithFrontStyle],
    productDropped: [addProduct]
  },
  cluster: [],
  sortOrder: [{ path: 'dimensions.height' }, { path: 'dimensions.depth' }]
};

export default framesProductListConfig;
